import { HStack, Text } from "@chakra-ui/react"
import { ConnectStores } from "lib/core/store"

const RegisterDisplayPrice = function ({ displayStatus }) {
  const { price, interval, included } = displayStatus

  if (price == null) {
    return null
  }

  return (
    <HStack as="span" className="RegisterDisplayPrice">
      <strong>{price}</strong>
      {interval ? (
        // The -2 ml removes the default 2 spacing between the price and interval
        // added by the parent HStack, while the parent HStack ensures the ":before"
        // "*" will be spaced appropriately.
        <Text as="span" color="inherit" ml="-2">
          {interval}
        </Text>
      ) : undefined}
    </HStack>
  )
}

RegisterDisplayPrice.displayName = "RegisterDisplayPrice"

const mapStateToProps = function (state, ownProps) {
  const displayStatus = state.registerStore.request.displayStatus()

  return _.assign(
    {},
    {
      displayStatus
    },
    ownProps
  )
}

const stores = [{ store: "register", watch: ["display_price"] }]

export default ConnectStores(RegisterDisplayPrice, stores, {}, mapStateToProps)
